import { default as app_45storeoLBCdQNRNJMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/app-store.vue?macro=true";
import { default as attendance03L73dPpNGMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/attendance.vue?macro=true";
import { default as end_45event_45listBNrGE7zdArMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/end-event-list.vue?macro=true";
import { default as event_45listr22uqH0GLTMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event-list.vue?macro=true";
import { default as event_45testGGoK8rm2rEMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event-test.vue?macro=true";
import { default as _91eventId_93dqc4WONjY9Meta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/[eventId].vue?macro=true";
import { default as BLUE_45ARCHIVE7SSIrWtIcHMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/BLUE-ARCHIVE.vue?macro=true";
import { default as GUARDIAN_TALES7ublDDhFAlMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/GUARDIAN_TALES.vue?macro=true";
import { default as GUARDIAN_45TALESoqG2jq7DOjMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/GUARDIAN-TALES.vue?macro=true";
import { default as PLKEY_4514pMF6e46joMMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/PLKEY-14.vue?macro=true";
import { default as PLKEY_4515xrvpJopI4lMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/PLKEY-15.vue?macro=true";
import { default as PLKEY_4517lj2TAPRinjMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/PLKEY-17.vue?macro=true";
import { default as PRICONNE_45THEMEw8Q1pUwTmvMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/PRICONNE-THEME.vue?macro=true";
import { default as WHATS_NEW_45GT4_45ENOfKlyzpQx3Meta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/WHATS_NEW-GT4-EN.vue?macro=true";
import { default as WHATS_NEW_45GT4X4AzG0fy0jMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/WHATS_NEW-GT4.vue?macro=true";
import { default as WHATS_NEW_45PRICONNEONLvHWSFlmMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/WHATS_NEW-PRICONNE.vue?macro=true";
import { default as homed72svVZQajMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/home.vue?macro=true";
import { default as storeWvbPijwVrFMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/store.vue?macro=true";
import { default as testcIeudozgriMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/test.vue?macro=true";
import { default as theme_45selectorRDZPWfurXyMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/theme-selector.vue?macro=true";
import { default as your_45emotionsY22unjfXZoMeta } from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/your-emotions.vue?macro=true";
export default [
  {
    name: app_45storeoLBCdQNRNJMeta?.name ?? "app-store",
    path: app_45storeoLBCdQNRNJMeta?.path ?? "/app-store",
    meta: app_45storeoLBCdQNRNJMeta || {},
    alias: app_45storeoLBCdQNRNJMeta?.alias || [],
    redirect: app_45storeoLBCdQNRNJMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/app-store.vue").then(m => m.default || m)
  },
  {
    name: attendance03L73dPpNGMeta?.name ?? "attendance",
    path: attendance03L73dPpNGMeta?.path ?? "/attendance",
    meta: attendance03L73dPpNGMeta || {},
    alias: attendance03L73dPpNGMeta?.alias || [],
    redirect: attendance03L73dPpNGMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/attendance.vue").then(m => m.default || m)
  },
  {
    name: end_45event_45listBNrGE7zdArMeta?.name ?? "end-event-list",
    path: end_45event_45listBNrGE7zdArMeta?.path ?? "/end-event-list",
    meta: end_45event_45listBNrGE7zdArMeta || {},
    alias: end_45event_45listBNrGE7zdArMeta?.alias || [],
    redirect: end_45event_45listBNrGE7zdArMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/end-event-list.vue").then(m => m.default || m)
  },
  {
    name: event_45listr22uqH0GLTMeta?.name ?? "event-list",
    path: event_45listr22uqH0GLTMeta?.path ?? "/event-list",
    meta: event_45listr22uqH0GLTMeta || {},
    alias: event_45listr22uqH0GLTMeta?.alias || [],
    redirect: event_45listr22uqH0GLTMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event-list.vue").then(m => m.default || m)
  },
  {
    name: event_45testGGoK8rm2rEMeta?.name ?? "event-test",
    path: event_45testGGoK8rm2rEMeta?.path ?? "/event-test",
    meta: event_45testGGoK8rm2rEMeta || {},
    alias: event_45testGGoK8rm2rEMeta?.alias || [],
    redirect: event_45testGGoK8rm2rEMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event-test.vue").then(m => m.default || m)
  },
  {
    name: _91eventId_93dqc4WONjY9Meta?.name ?? "event-eventId",
    path: _91eventId_93dqc4WONjY9Meta?.path ?? "/event/:eventId()",
    meta: _91eventId_93dqc4WONjY9Meta || {},
    alias: _91eventId_93dqc4WONjY9Meta?.alias || [],
    redirect: _91eventId_93dqc4WONjY9Meta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/[eventId].vue").then(m => m.default || m)
  },
  {
    name: BLUE_45ARCHIVE7SSIrWtIcHMeta?.name ?? "event-BLUE-ARCHIVE",
    path: BLUE_45ARCHIVE7SSIrWtIcHMeta?.path ?? "/event/BLUE-ARCHIVE",
    meta: BLUE_45ARCHIVE7SSIrWtIcHMeta || {},
    alias: BLUE_45ARCHIVE7SSIrWtIcHMeta?.alias || [],
    redirect: BLUE_45ARCHIVE7SSIrWtIcHMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/BLUE-ARCHIVE.vue").then(m => m.default || m)
  },
  {
    name: GUARDIAN_TALES7ublDDhFAlMeta?.name ?? "event-GUARDIAN_TALES",
    path: GUARDIAN_TALES7ublDDhFAlMeta?.path ?? "/event/GUARDIAN_TALES",
    meta: GUARDIAN_TALES7ublDDhFAlMeta || {},
    alias: GUARDIAN_TALES7ublDDhFAlMeta?.alias || [],
    redirect: GUARDIAN_TALES7ublDDhFAlMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/GUARDIAN_TALES.vue").then(m => m.default || m)
  },
  {
    name: GUARDIAN_45TALESoqG2jq7DOjMeta?.name ?? "event-GUARDIAN-TALES",
    path: GUARDIAN_45TALESoqG2jq7DOjMeta?.path ?? "/event/GUARDIAN-TALES",
    meta: GUARDIAN_45TALESoqG2jq7DOjMeta || {},
    alias: GUARDIAN_45TALESoqG2jq7DOjMeta?.alias || [],
    redirect: GUARDIAN_45TALESoqG2jq7DOjMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/GUARDIAN-TALES.vue").then(m => m.default || m)
  },
  {
    name: PLKEY_4514pMF6e46joMMeta?.name ?? "event-PLKEY-14",
    path: PLKEY_4514pMF6e46joMMeta?.path ?? "/event/PLKEY-14",
    meta: PLKEY_4514pMF6e46joMMeta || {},
    alias: PLKEY_4514pMF6e46joMMeta?.alias || [],
    redirect: PLKEY_4514pMF6e46joMMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/PLKEY-14.vue").then(m => m.default || m)
  },
  {
    name: PLKEY_4515xrvpJopI4lMeta?.name ?? "event-PLKEY-15",
    path: PLKEY_4515xrvpJopI4lMeta?.path ?? "/event/PLKEY-15",
    meta: PLKEY_4515xrvpJopI4lMeta || {},
    alias: PLKEY_4515xrvpJopI4lMeta?.alias || [],
    redirect: PLKEY_4515xrvpJopI4lMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/PLKEY-15.vue").then(m => m.default || m)
  },
  {
    name: PLKEY_4517lj2TAPRinjMeta?.name ?? "event-PLKEY-17",
    path: PLKEY_4517lj2TAPRinjMeta?.path ?? "/event/PLKEY-17",
    meta: PLKEY_4517lj2TAPRinjMeta || {},
    alias: PLKEY_4517lj2TAPRinjMeta?.alias || [],
    redirect: PLKEY_4517lj2TAPRinjMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/PLKEY-17.vue").then(m => m.default || m)
  },
  {
    name: PRICONNE_45THEMEw8Q1pUwTmvMeta?.name ?? "event-PRICONNE-THEME",
    path: PRICONNE_45THEMEw8Q1pUwTmvMeta?.path ?? "/event/PRICONNE-THEME",
    meta: PRICONNE_45THEMEw8Q1pUwTmvMeta || {},
    alias: PRICONNE_45THEMEw8Q1pUwTmvMeta?.alias || [],
    redirect: PRICONNE_45THEMEw8Q1pUwTmvMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/PRICONNE-THEME.vue").then(m => m.default || m)
  },
  {
    name: WHATS_NEW_45GT4_45ENOfKlyzpQx3Meta?.name ?? "event-WHATS_NEW-GT4-EN",
    path: WHATS_NEW_45GT4_45ENOfKlyzpQx3Meta?.path ?? "/event/WHATS_NEW-GT4-EN",
    meta: WHATS_NEW_45GT4_45ENOfKlyzpQx3Meta || {},
    alias: WHATS_NEW_45GT4_45ENOfKlyzpQx3Meta?.alias || [],
    redirect: WHATS_NEW_45GT4_45ENOfKlyzpQx3Meta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/WHATS_NEW-GT4-EN.vue").then(m => m.default || m)
  },
  {
    name: WHATS_NEW_45GT4X4AzG0fy0jMeta?.name ?? "event-WHATS_NEW-GT4",
    path: WHATS_NEW_45GT4X4AzG0fy0jMeta?.path ?? "/event/WHATS_NEW-GT4",
    meta: WHATS_NEW_45GT4X4AzG0fy0jMeta || {},
    alias: WHATS_NEW_45GT4X4AzG0fy0jMeta?.alias || [],
    redirect: WHATS_NEW_45GT4X4AzG0fy0jMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/WHATS_NEW-GT4.vue").then(m => m.default || m)
  },
  {
    name: WHATS_NEW_45PRICONNEONLvHWSFlmMeta?.name ?? "event-WHATS_NEW-PRICONNE",
    path: WHATS_NEW_45PRICONNEONLvHWSFlmMeta?.path ?? "/event/WHATS_NEW-PRICONNE",
    meta: WHATS_NEW_45PRICONNEONLvHWSFlmMeta || {},
    alias: WHATS_NEW_45PRICONNEONLvHWSFlmMeta?.alias || [],
    redirect: WHATS_NEW_45PRICONNEONLvHWSFlmMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/event/WHATS_NEW-PRICONNE.vue").then(m => m.default || m)
  },
  {
    name: homed72svVZQajMeta?.name ?? "home",
    path: homed72svVZQajMeta?.path ?? "/home",
    meta: homed72svVZQajMeta || {},
    alias: homed72svVZQajMeta?.alias || [],
    redirect: homed72svVZQajMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/home.vue").then(m => m.default || m)
  },
  {
    name: storeWvbPijwVrFMeta?.name ?? "store",
    path: storeWvbPijwVrFMeta?.path ?? "/store",
    meta: storeWvbPijwVrFMeta || {},
    alias: storeWvbPijwVrFMeta?.alias || [],
    redirect: storeWvbPijwVrFMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/store.vue").then(m => m.default || m)
  },
  {
    name: testcIeudozgriMeta?.name ?? "test",
    path: testcIeudozgriMeta?.path ?? "/test",
    meta: testcIeudozgriMeta || {},
    alias: testcIeudozgriMeta?.alias || [],
    redirect: testcIeudozgriMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/test.vue").then(m => m.default || m)
  },
  {
    name: theme_45selectorRDZPWfurXyMeta?.name ?? "theme-selector",
    path: theme_45selectorRDZPWfurXyMeta?.path ?? "/theme-selector",
    meta: theme_45selectorRDZPWfurXyMeta || {},
    alias: theme_45selectorRDZPWfurXyMeta?.alias || [],
    redirect: theme_45selectorRDZPWfurXyMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/theme-selector.vue").then(m => m.default || m)
  },
  {
    name: your_45emotionsY22unjfXZoMeta?.name ?? "your-emotions",
    path: your_45emotionsY22unjfXZoMeta?.path ?? "/your-emotions",
    meta: your_45emotionsY22unjfXZoMeta || {},
    alias: your_45emotionsY22unjfXZoMeta?.alias || [],
    redirect: your_45emotionsY22unjfXZoMeta?.redirect,
    component: () => import("/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/pages/your-emotions.vue").then(m => m.default || m)
  }
]